<template>
	<div
		class="mc-tree-node"
		@click.stop="handleClick"
		@contextmenu="($event) => this.handleContextMenu($event)"
		v-show="node.visible"
		:class="{
		  'is-expanded': expanded,
		  'is-current': tree.store.currentNode === node,
		  'is-hidden': !node.visible,
		  'is-focusable': !node.disabled,
		  'is-checked': !node.disabled && node.checked
		}"
		role="treeitem"
		tabindex="-1"
		ref="node"
		:aria-expanded="expanded"
		:aria-disabled="node.disabled"
		:aria-checked="node.checked"
		:style="{

		}">
		<div
				class="mc-tree-node__content"
				ref="content"
				:style="{
					'padding-left': 40 * (node.level -1) + 'px'
				}"
		>
			<div class="mc-tree-node__content-container">
				<div class="mc-tree-node__icon-container">
				<span
						class="mc-tree-node__expand-icon fa "
						@click.stop="handleExpandIconClick"
						:style="{'width':(tree.indent - 12) + 'px'}"
						:class="{ 'is-leaf': node.isLeaf, 'fa-minus-square': !node.isLeaf && expanded ,'fa-plus-square': (!node.isLeaf && !expanded)}">
                </span>
				</div>
				<mc-checkbox
						v-if="showCheckbox"
						v-model="node.checked"
						:indeterminate="node.indeterminate"
						:disabled="!!node.disabled"
						@click.native.stop
						@change="handleCheckChange"
				>
				</mc-checkbox>
				<span
						v-if="node.loading"
						class="mc-tree-node__loading-icon el-icon-loading">
            </span>
				<node-content :node="node"></node-content>
			</div>
		</div>
		<!-- 连父结点 -->
		<hr class="line-before"
			:style="{
				'left': 40 * (node.level - 1) + 'px',
		    	'top': -(contentHeight/2 - 12) + 'px',	 			//  -(叶结点高/2 - 字高)
		    	'height': (contentHeight/2 - (node.isLeaf?6:12)) * 2 + 'px',  		//  中间结点：（叶结点高/2 - 字高） * 2
//		    	'height': (30/2 - 12) * 2  + 'px'     // 叶结点：（叶结点高/2 - 2 +top值） * 2

			}" />
		<!-- 连同级结点 -->
		<hr class="line-after"
			:style="{
				'left': 40 * (node.level - 1) + 'px',
		    	'top': (contentHeight/2) + (node.isLeaf?1:12) + 'px',		// 叶结点高/2 + 字高
		    	'bottom': -(contentHeight/2) + (isNextBroLeaf?0:12) + 'px',	// 中间结点：叶结点高/2 - 字高
//		    	'bottom': -(30/2 - 12) + 'px'		// 最后结点：叶结点高/2

			}" />
		<el-collapse-transition>
			<div
					class="mc-tree-node__children"
					v-if="!renderAfterExpand || childNodeRendered"
					v-show="expanded"
					role="group"
					:aria-expanded="expanded"
			>
				<el-tree-node
						:render-content="renderContent"
						v-for="child in node.childNodes"
						:render-after-expand="renderAfterExpand"
						:key="getNodeKey(child)"
						:node="child"
						@node-expand="handleChildNodeExpand">
				</el-tree-node>
			</div>
		</el-collapse-transition>
		<!--<div :style="{-->
						    <!--'left': (node.level - 1) * tree.indent + 8-1 + 'px',-->
						     <!--'top': contentHeight/2 + 8 + 'px',-->
						     <!--'height': nodeHeight - (isChildLeaf?8:16) + 'px'-->
						<!--}"-->
			 <!--v-if="hasBroLink"-->
			 <!--class="mc-tree-node__bro-link">-->

		<!--</div>-->
	</div>
</template>

<script type="text/jsx">
    import ElCollapseTransition from '../transitions/collapse-transition';
    // import ElCheckbox from './base-switch';
    import McCheckbox from './base-checkbox';
    import emitter from '../mixins/emitter';
    import {getNodeKey} from '../model/util';

    export default {
        name: 'ElTreeNode',

        componentName: 'ElTreeNode',

        mixins: [emitter],

        props: {
            node: {
                default() {
                    return {};
                }
            },
            props: {},
            renderContent: Function,
            renderAfterExpand: {
                type: Boolean,
                default: true
            }
        },

        components: {
            ElCollapseTransition,
            McCheckbox,
            NodeContent: {
                props: {
                    node: {
                        required: true
                    }
                },
                render(h) {
                    const parent = this.$parent;
                    const tree = parent.tree;
                    const node = this.node;
                    const {data, store} = node;
                    return (
                        parent.renderContent
                            ? parent.renderContent.call(parent._renderProxy, h, {
                                _self: tree.$vnode.context,
                                node,
                                data,
                                store
                            })
                            : tree.$scopedSlots.default
                            ? tree.$scopedSlots.default({node, data})
                            : <span class="mc-tree-node__label">{this.node.label}</span>
                    );
                }
            }
        },

        data() {
            return {
                tree: null,
                expanded: false,
                childNodeRendered: false,
                contentHeight: 0,
                nodeHeight: 0,
				hasBroLink: false,
                showCheckbox: false,
                oldChecked: null,
                oldIndeterminate: null
            };
        },

		computed: {
            isChildLeaf(){
                const childNodes = this.node.childNodes;
                if(childNodes && childNodes.length){
                    return childNodes[0].isLeaf
                }else {
                    return false;
                }
            },
            isNextBroLeaf(){
                const currentId = this.node.id,
                    parent = this.node.parent,
                    bros = parent.childNodes,
                    index = bros.findIndex(b=>b.id===currentId),
                    nextBro = parent.childNodes[index+1];
                return nextBro && nextBro.isLeaf;
            }
		},
        watch: {
            'node.indeterminate'(val) {
                this.handleSelectChange(this.node.checked, val);
            },

            'node.checked'(val) {
                this.handleSelectChange(val, this.node.indeterminate);
            },

            'node.expanded'(val) {
                this.expanded = val;
                this.$nextTick(() => this.expanded = val);
                if (val) {
                    this.childNodeRendered = true;
                }

            },
	        'expanded'(){
                this.$nextTick(()=>{
                    setTimeout(()=>{
                        this.nodeHeight = this.getNodeHeight();
                    }, 50)
                });
            },
	        'node.childNodes': {
				deep: true,
		        handler(){
                    setTimeout(()=>{
                        this.nodeHeight = this.getNodeHeight();
                    }, 50)
		        }
	        },
			'node.parent.expanded':function (expanded){
                if(expanded === true){
                    this.contentHeight = this.getContentHeight();
                }
            }
        },

        methods: {
            hasNextBro(){
                const currentId = this.node.id,
					parent = this.node.parent,
					bros = parent.childNodes,
					childrenNum = bros.length,
					index = bros.findIndex(b=>b.id===currentId);
                return index !== childrenNum-1;
			},

            getNodeKey(node) {
                return getNodeKey(this.tree.nodeKey, node.data);
            },

            handleSelectChange(checked, indeterminate) {
                if (this.oldChecked !== checked && this.oldIndeterminate !== indeterminate) {
                    this.tree.$emit('check-change', this.node.data, checked, indeterminate);
                }
                this.oldChecked = checked;
                this.indeterminate = indeterminate;
            },

            handleClick() {
                const store = this.tree.store;
                store.setCurrentNode(this.node);
                this.tree.$emit('current-change', store.currentNode ? store.currentNode.data : null, store.currentNode);
                this.tree.currentNode = this;
                if (this.tree.expandOnClickNode) {
                    this.handleExpandIconClick();
                }
                this.tree.$emit('node-click', this.node.data, this.node, this);
            },

            handleContextMenu(event) {
                this.tree.$emit('node-contextmenu', event, this.node.data, this.node, this);
            },

            handleExpandIconClick() {
                if (this.node.isLeaf) return;
                if (this.expanded) {
                    this.tree.$emit('node-collapse', this.node.data, this.node, this);
                    this.node.collapse();
                } else {
                    this.node.expand();
                    this.$emit('node-expand', this.node.data, this.node, this);
                }
            },

            handleCheckChange(value, ev) {
                this.node.setChecked(ev.target.checked, !this.tree.checkStrictly);
                this.$nextTick(() => {
                    const store = this.tree.store;
                    this.tree.$emit('check', this.node.data, {
                        checkedNodes: store.getCheckedNodes(),
                        checkedKeys: store.getCheckedKeys(),
                        halfCheckedNodes: store.getHalfCheckedNodes(),
                        halfCheckedKeys: store.getHalfCheckedKeys(),
                    });
                });
            },

            handleChildNodeExpand(nodeData, node, instance) {
                this.broadcast('ElTreeNode', 'tree-node-expand', node);
                this.tree.$emit('node-expand', nodeData, node, instance);
            },
			getContentHeight(){
                const rects = this.$refs.content.getClientRects();
                if(rects && rects.length){
                    return rects[0].height;
                }else{
                    return 0;
				}
			},

	        getNodeHeight(){
                const rects = this.$refs.node.getClientRects();
                if(rects && rects.length){
                    return rects[0].height;
                }else{
                    return 0;
                }
	        }
        },

		mounted(){
            this.contentHeight = this.tree.props.innerHeight || this.getContentHeight();
            this.nodeHeight = this.getNodeHeight();
            this.hasBroLink = this.hasNextBro();
        },

        created() {
            const parent = this.$parent;

            if (parent.isTree) {
                this.tree = parent;
            } else {
                this.tree = parent.tree;
            }

            const tree = this.tree;
            if (!tree) {
                console.warn('Can not find node\'s tree.');
            }

            const props = tree.props || {};
            const childrenKey = props['children'] || 'children';
            this.$watch(`node.data.${childrenKey}`, () => {
                this.node.updateChildren();
            });

            this.showCheckbox = tree.showCheckbox;

            if (this.node.expanded) {
                this.expanded = true;
                this.childNodeRendered = true;
            }

            if (this.tree.accordion) {
                this.$on('tree-node-expand', node => {
                    if (this.node !== node) {
                        this.node.collapse();
                    }
                });
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/tree-node.vue